import React from 'react'
import { IoMdHelpCircle } from 'react-icons/io'
import { Box, IconButton } from '@chakra-ui/react'

const HelpPopoverTrigger: React.ReactNode = (
  <Box mx={2}>
    <IconButton
      aria-label="help"
      as={IoMdHelpCircle}
      cursor="pointer"
      size="xs"
      variant="ghost"
      color="gray.400"
      rounded="0"
    />
  </Box>
)

export default HelpPopoverTrigger
